import React from "react";

export const FailedIcon = ({ color = "#DC2804" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66699 9.99935C1.66699 5.40018 5.40033 1.66602 10.0003 1.66602C14.6087 1.66602 18.3337 5.40018 18.3337 9.99935C18.3337 14.6002 14.6087 18.3327 10.0003 18.3327C5.40033 18.3327 1.66699 14.6002 1.66699 9.99935ZM9.26699 6.84102C9.26699 6.44185 9.60033 6.10768 10.0003 6.10768C10.4003 6.10768 10.7253 6.44185 10.7253 6.84102V10.5243C10.7253 10.9252 10.4003 11.2493 10.0003 11.2493C9.60033 11.2493 9.26699 10.9252 9.26699 10.5243V6.84102ZM10.0087 13.9002C9.60033 13.9002 9.27533 13.5668 9.27533 13.1668C9.27533 12.7668 9.60033 12.4418 10.0003 12.4418C10.4087 12.4418 10.7337 12.7668 10.7337 13.1668C10.7337 13.5668 10.4087 13.9002 10.0087 13.9002Z"
        fill={color}
      />
    </svg>
  );
};
